import libraries from './libraries';
import { getLibTitle } from './libraryTitles'

function getLibraryInfos () {
    var req = new XMLHttpRequest();
    req.open('GET', document.location, false);
    req.send(null);
    let str = req.getAllResponseHeaders();
    let strList = str.split('\n');
    for (let item of strList) {
        if (item.indexOf('library') !== -1) {
            let infoStr = item.replace('\r', '');
            while (infoStr.indexOf(' ') !== -1) { infoStr = infoStr.replace(' ', '') }
            let libStrs = infoStr.split(':');
            if (libStrs.length === 2) {
                return {
                    name: libraries.libs[libStrs[1]],
                    libraryTitle: getLibTitle(libStrs[1]),
                    code: libStrs[1]
                }
            }
        }
    }

    return {
        name: '西昌市地方志编纂中心',
        libraryTitle: '西昌市地方志编纂中心',
        code: '240901'
    }
}

// 图书馆名称
const libraryName = '连云港市图书馆'
const libraryCode = '1008'
export default {
    libraryName,
    libraryCode,
    getLibraryInfos
};
